import { useCallback, useEffect, useRef } from 'react';
import { WarningMessage, useMessageService } from 'framework/ui/Message';

const useSyberryTodaySystemWarning = () => {
  const { addMessage, cleanMessage } = useMessageService();
  const addMessageRef = useRef(addMessage);
  const cleanMessageRef = useRef(cleanMessage);
  const currentWarningRef = useRef<Nullable<WarningMessage>>(null);

  useEffect(() => {
    addMessageRef.current = addMessage;
    cleanMessageRef.current = cleanMessage;
  }, [addMessage, cleanMessage]);

  return useCallback((message: Nullable<string>) => {
    const currentWarning = currentWarningRef.current;

    if (!message) {
      if (currentWarning) {
        cleanMessageRef.current(currentWarning);
        currentWarningRef.current = null;
      }

      return;
    }

    if (currentWarning?.content === message) return;

    if (currentWarning) {
      cleanMessageRef.current(currentWarning);
    }

    const nextWarning = new WarningMessage(message);

    currentWarningRef.current = nextWarning;
    addMessageRef.current(nextWarning);
  }, []);
};

export default useSyberryTodaySystemWarning;
